// console.log( 'hello from within sw.js' );
// console.log( 'window:', window );
import { store } from './vuex/store';


if( 'serviceWorker' in navigator ){

    // console.log( 'sw in navigator:', navigator );
    // console.log( 'store is: ', store );
}

self.addEventListener( 'beforeinstallprompt', ( e ) => {

    // Prevent Chrome 67 and earlier from automatically showing the prompt
    // e.preventDefault();
    // Stash the event so it can be triggered later.
    console.log( 'install prompt issued' );
    // store.dispatch( 'pwa/toggleInstallable', e );
});

if ( !window.matchMedia( '(display-mode: standalone)' ).matches ) {

    store.dispatch( 'pwa/toggleInstallable' );
    // console.log( "this is not being displayed as a pwa in standalone mode" );
} else console.log( "This is running as standalone." );